import { APIClient } from "./_api";

export function getAdvertises(data) {
  return APIClient.post(`listAdv`, data);
}
export function addAdvertises(data) {
  return APIClient.post(`regAdv`, data);
}
export function getAdvDetail(data) {
  return APIClient.post(`viewAdv`, data);
}
export function getSpecialties(data) {
  return APIClient.post(`specialties`, data);
}
export function getFields(data) {
  return APIClient.post(`fields`, data);
}
export function getUniversities(data) {
  return APIClient.post(`universites`, data);
}
export function bidToAdv(data) {
  return APIClient.post(`bidToAdv`, data);
}
export function myAdv(data) {
  return APIClient.post(`listMyAdv`, data);
}
export function removeAdv(data) {
  return APIClient.post(`removeAdv`, data);
}
export function viewMyAdv(data) {
  return APIClient.post(`viewMyAdv`, data);
}
export function viewBidAdv(data) {
  return APIClient.post(`listBidAdv`, data);
}
export function editAdvertise(data) {
  return APIClient.post(`editAdv`, data);
}
export function verifyProject(data) {
  return APIClient.post(`verifyProject`, data);
}
export function myAdvVisits(data) {
  return APIClient.post(`myAdvVisits`, data);
}
